// Auto-generated by pipeline
export const firebaseConfig = {
  "authDomain": "weburn-edm.firebaseapp.com",
  "projectId": "weburn-edm",
  "storageBucket": "weburn-edm.appspot.com",
  "messagingSenderId": "521862771749",
  "appId": "1:521862771749:web:345d6f2ae81204bb383bcc",
  "measurementId": "G-0PQ6M6HDGM",
  "apiKey": "AIzaSyDdwnxmUoP2nOyOKQ_NLs9fAbwWOVbmhDc"
};
